import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FadeUp } from "./RevealText";
import { useLang, T } from "../../lib/i18n";

const media = [
  {
    n: "01",
    img: "https://customer-assets-gfyr7b9c.emergentagent.net/job_caribbean-nye/artifacts/lkao93ex_Screenshot%2B2024-04-09%2Bat%2B2.03.32%E2%80%AFp.m..webp",
    alt: "Panoramic aerial view of Saint Martin",
  },
  {
    n: "02",
    img: "https://static.prod-images.emergentagent.com/jobs/0ad0107d-2ba5-47b5-a6e3-cec575f7e0ce/images/e79754704fb74898c6bcea8c8a5dec1df72f26adbf70b9dfb1036fd2416dd2f2.jpeg",
    alt: "DJ playing at golden hour on the beach",
  },
  {
    n: "03",
    img: "https://static.prod-images.emergentagent.com/jobs/0ad0107d-2ba5-47b5-a6e3-cec575f7e0ce/images/7274f226f2936c4709cece028291e92f1e1cbd8d4daa9da5884db242d9c1f092.jpeg",
    alt: "New Year celebration with fireworks and champagne on a Saint Martin beach",
  },
];

const Chapter = ({ c, i }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const reverse = i % 2 === 1;

  return (
    <div ref={ref} data-testid={`manifesto-chapter-${c.n}`} className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16 items-center ${i > 0 ? "mt-24 md:mt-40" : ""}`}>
      <FadeUp className={`md:col-span-5 ${reverse ? "md:order-2 md:col-start-8" : ""}`}>
        <span className="font-serif italic text-7xl md:text-8xl text-[#00B4D8]/25 leading-none">{c.n}</span>
        <h3 className="font-serif text-3xl md:text-5xl tracking-tight text-slate-900 mt-4">{c.title}</h3>
        <p className="text-slate-500 text-base md:text-lg leading-relaxed mt-6 max-w-md">{c.text}</p>
      </FadeUp>
      <FadeUp delay={0.15} className={`md:col-span-6 ${reverse ? "md:order-1 md:col-start-1" : "md:col-start-7"}`}>
        <div className="overflow-hidden rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.08)]">
          <motion.img style={{ y }} src={c.img} alt={c.alt} loading="lazy" className="w-full h-[320px] md:h-[460px] object-cover scale-110" />
        </div>
      </FadeUp>
    </div>
  );
};

export const Manifesto = () => {
  const { lang } = useLang();
  const t = T[lang].manifesto;
  const chapters = media.map((m, i) => ({ ...m, ...t.chapters[i] }));
  return (
    <section data-testid="manifesto-section" className="max-w-[1440px] mx-auto px-5 md:px-10 py-24 md:py-40">
      <FadeUp>
        <p className="text-xs uppercase tracking-[0.3em] text-[#00B4D8] mb-5">{t.kicker}</p>
        <h2 className="font-serif text-4xl md:text-6xl tracking-tight text-slate-900 max-w-3xl leading-[1.05]">
          {t.title1} <span className="italic text-[#FF7F50]">{t.titleAccent}</span> {t.title2}
        </h2>
      </FadeUp>
      <div className="mt-20 md:mt-32">
        {chapters.map((c, i) => (
          <Chapter key={c.n} c={c} i={i} />
        ))}
      </div>
    </section>
  );
};
